import { render, staticRenderFns } from "./LayoutSuperAdmin.vue?vue&type=template&id=64d10a18&"
import script from "./LayoutSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./LayoutSuperAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports